<template>
  <page-skeleton>
    <template slot="header-left">
      <el-button size="medium" type="primary" round @click="editFabric('add')">添加面料分类</el-button>
    </template>

    <template slot="container">
      <el-table v-loading="loading" :data="tableData" ref="multipleTable" style="width: 100%" height="100%" class="fabric-table"
        :row-key="(row) => row.id+''"
        :tree-props="{ children: 'children' }"
        :expand-row-keys="expands"
        @expand-change="expandChange">
        <!-- <el-table-column width="140">
          <div slot-scope="{row}" class="sort-icon" :style="{left: `calc(${2 * row.level}0% - ${(row.level-1)*10}px)`}">
            <i class="iconfont icon-line-height a-icon" />
          </div>
        </el-table-column> -->
        <el-table-column label="面料分类名称" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ row.languageList[1].name }}({{ row.languageList[0].name }})
          </template>
        </el-table-column>


        <el-table-column prop="fabricQty" label="商品数量" show-overflow-tooltip />
        <el-table-column v-slot="scope" label="操作" width="140">
          <el-button type="text" size="medium" @click="() => editFabric('edit',scope.row)">编辑</el-button>
          <el-button v-if="scope.row.parentId" type="text" size="medium" @click="deleteFabricCategory(scope.row)">删除</el-button>
          <el-dropdown v-else style="margin-left:10px" @command="(e) => handleCommand(e, scope.row)" trigger="click">
            <span class="el-dropdown-link">
              <el-button type="text" size="medium">更多</el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">添加子类</el-dropdown-item>
              <el-dropdown-item :command="2">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
    </template>

    <!-- <template slot="footer-right">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </template> -->

    <EditCategory ref="editCategory" @confirm="resetPage" />
  </page-skeleton>
</template>

<script>
import API from '@/api'
import PageSkeleton from '@/components/PageSkeleton.vue'
import { createSortTable } from '@/views/js/treeSortable'
import EditCategory from './components/editCategory.vue'

export default {
  name: 'supply_fabric',
  components: {
    PageSkeleton,
    EditCategory
  },
  data() {
    return {
      loading: false,
      // parameter: {
      //   pageSize: 20,
      //   pageNumber: 1
      // }, // 获取品类列表的请求参数
      total: 0, // 分页总数
      tableData: [],
      sortList: [],
      expands: [], // 指定展开ids
      sortable: null, // sortable对象
      tiledTable: [], // 平铺table数据
      tableKey: '', // 刷新table
    }
  },
  created() {
  },
  mounted() {
    this.getCategoriesTree()
  },
  methods: {
    // 初始化拖拽表格
    // initSortTable() {
    //   const el = this.$refs.multipleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
    //   const _this = this
    //   this.sortable = createSortTable(el, this.tiledTable, (oldIndex, newIndex) => {
    //     let param = { type: 2 }
    //     _this.tiledTable.forEach((item, i) => {
    //       if (i === oldIndex) param = { ...param, position: item.orderNum, id: item.id }
    //       else if (i === newIndex) param = { ...param, targetPosition: item.orderNum, targetId: item.id }
    //     })

    //     API.getCategoriesTree(param).then(res => {
    //       if (res.code !== 10000) return _this.$message.error(res.message)
    //       _this.getCategoryList()
    //     })
    //   })
    // },

    getCategoriesTree() {
      API.getCategoriesTree().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.tableData = res.data.list
      })
    },
    // 展开指定行
    expandChange(row, expands) {
      if (expands) this.expands.push(row.id+'')
      else this.expands.splice(this.expands.indexOf(row.id+''), 1)
    },

    resetPage() {
      // this.parameter.pageNumber = 1
      this.getCategoriesTree()
    },

    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getCategoriesTree()
    },

    // 上一页/下一页/当前页发生改变时的回调
    handleCurrentChange(current) {
      this.parameter.pageNumber = current
      this.getCategoriesTree()
    },

    handleCommand(command, row) {
      if (command === 1) return this.editFabric('subclass', row)
      if (command === 2) return this.deleteFabricCategory(row)
    },

    editFabric(type, row) {
      this.$refs.editCategory.show(type, row)
    },
    deleteFabricCategory(row) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          API.deleteFabricCategory({
            id: row.id
          }).then(res => {
            if (res.code !== 10000) return this.$message.error(res.message)
            this.$message.success('删除成功')
            this.resetPage()
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-skeleton {
  min-width: 1200px !important;
}
.fabric-table {
  /deep/ .el-table__cell .cell {
    position: relative;
    min-height: 20px;
    display: flex;
    .sort-icon {
      width: 26px;
      position: absolute;
    }
  }
}
</style>